var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "cu-stroke",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    strokeDasharray: 3,
    className: "cu-stroke-dasharray",
    stroke: "#979797",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 9)",
    strokeWidth: "0.907px",
    fill: "none",
    fillRule: "evenodd",
    className: "cu-stroke",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92000816 2.20001359L1.92000816 4.92000816C1.92000816 7.17332545 3.7466827 9 6 9 8.2533173 9 10.0799918 7.17332545 10.0799918 4.92000816L10.0799918 2.20001359 1.92000816 2.20001359zM1.92000816 15.7999864L10.0799918 15.7999864 10.0799918 13.0799918C10.0799918 10.8266745 8.2533173 9 6 9 3.7466827 9 1.92000816 10.8266745 1.92000816 13.0799918L1.92000816 15.7999864z",
    stroke: "#979797",
    fill: "none",
    strokeWidth: "0.907px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.107,
    y: 0.387,
    width: 11.787,
    height: 1.813,
    rx: 0.907,
    stroke: "#979797",
    fill: "none",
    strokeWidth: "0.907px"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.107,
    y: 15.8,
    width: 11.787,
    height: 1.813,
    rx: 0.907,
    stroke: "#979797",
    fill: "none",
    strokeWidth: "0.907px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimate);
export default __webpack_public_path__ + "static/media/estimate.e5b6c0baaaa934b18d67d121fe8520fb.svg";
export { ForwardRef as ReactComponent };